import React from "react"
import "./Loading.scss"
import { StaticImage } from "gatsby-plugin-image"

const Loading = () => {
  return (
    <div className="loading">
      <StaticImage
        className="loading-logo"
        src="../../images/logo.png"
        layout="fullWidth"
        alt="Mirai Magical School Winter Festival"
      />
    </div>
  )
}

export default Loading
